import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';

import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';

import JobTaskHeader from './JobTaskHeader';
import JobTaskItems from './JobTaskItems';

import { startRemoveBidTask } from '../../../../store/actions/bids';

const styles = theme => ({
  root: {
    margin: theme.spacing.unit*2,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  actions: {
    margin: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing.unit,
  },
});

const JobTaskGeneric = ({ classes, bidTask, preview, startRemoveBidTask }) => {

  return(
      <Card className={classes.root}>
        <JobTaskHeader preview={preview} bidTask={bidTask} />
        {bidTask.type==="quote" &&
          <div className={classes.content}>
            <JobTaskItems preview={preview} type="Labor" bidTask={bidTask} />
            <JobTaskItems preview={preview} type="Materials" bidTask={bidTask} />
          </div>
        }
        {!preview &&
          <div className={classes.actions}>
            <Button
              aria-label="delete"
              size="small"
              className={classes.deleteButton}
              onClick={() => startRemoveBidTask(bidTask.id)}
              style={{color: 'grey'}}
              >
              <DeleteIcon />
            </Button>
          </div>
        }
      </Card>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startRemoveBidTask: (bidTaskId) => dispatch(startRemoveBidTask(bidTaskId)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps),
)(JobTaskGeneric);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/JobTaskGeneric.jsx